import { gql } from "@apollo/client";

const ORGANIZATION_PHOTOS = gql`
  query organizationQuery(
    $id: ID!
    $take: Int
    $cursor: ID
    $filters: OrganizationMediaFilters
  ) {
    organization(id: $id) {
      id
      photosCount
      media(type: "IMAGE", take: $take, cursor: $cursor, filters: $filters) {
        id
        createdAt
        type
        subtype
        isExternal
        filename
        public
        aspectRatio
        clapCount
        isClapped
        canManageMedia
        contentLength
      }
    }
  }
`;

export default ORGANIZATION_PHOTOS;
